<template>
  <div class="product-section">
    <div class="df vertical df-around">
      <div class="title">{{ query.localDate }} 工位检查</div>
      <a-space>
        <!-- <select-day
          :defaultVal="query.localDate"
          @userDelectDay="userSelectDay"
        ></select-day> -->
        <!-- <a-button @click="handleUpdateAbnormalProblem(null)">新增</a-button> -->
      </a-space>
    </div>
    <form-vue
      ref="fqcRef"
      @updateTable="updateTable"
      :type="props.type"
      :produceOrTpc="props.produceOrTpc"
    ></form-vue>
    <div ref="tableScrollRef">
      <div class="df both-side" style="margin-top: 20px">
        <div style="margin: 0 auto; width: calc(100vw - 160px)">
          <a-table
            :columns="productColumns"
            :loading="tableLoading"
            :data-source="tableData"
            :pagination="false"
            :rowClassName="
              (record, index) => (index % 1 === 0 ? 'table-striped' : null)
            "
            rowKey="id"
            bordered
            :scroll="{ x: 'calc(100vw - 160px)' }"
          >
            <template #action="{ record }">
              <a-space>
                <a-button @click="handleEdit(record)" size="small"
                  >编辑</a-button
                >

                <a-button
                  v-if="props.deleteAuthority && record.id"
                  @click="handleDelete(record)"
                  size="small"
                  type="danger"
                  >删除</a-button
                >
              </a-space>
            </template>

            <template #checkResults="{ record }">
              <div v-if="record.checkResults !== null">
                {{ record.checkResults === true ? "合格" : "不合格" }}
              </div>
            </template>

            <template #picture="{ record }">
              <a-image
                v-for="img in JSON.parse(record.picture)"
                :key="img"
                :width="50"
                :src="img"
              />
            </template>

            <template #video="{ record }">
              <video
                v-for="video in JSON.parse(record.video)"
                :src="video"
                controls
                width="120"
                :key="video"
              ></video>
            </template>

            <template #isEducation="{ record }">
              <div v-if="record.isEducation !== null">
                {{ record.isEducation ? "是" : "否" }}
              </div>
            </template>

            <template #isTrain="{ record }">
              <div v-if="record.isEducation !== null">
                {{ record.isTrain ? "是" : "否" }}
              </div>
            </template>
          </a-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, reactive, ref, inject, watch } from "vue";
import {
  getStationCheckList,
  deleteStationCheck,
} from "@/request/view/product";
import searchVue from "@/views/productDaily/components/quality/PQC/threePieced/search.vue";
import formVue from "@/views/productDaily/components/product/components/stationCheck/form.vue";
import SelectDay from "@/views/repairprogress/compoments/selectDay.vue";
import { showModal } from "@/views/repairprogress/serve/modal";
import { useStore } from "vuex";
import { Toast, debounce, timeStampToTime } from "@/utils";

export default defineComponent({
  props: {
    deleteAuthority: Boolean,
    type: String,
    produceOrTpc: String,
  },
  components: {
    searchVue,
    formVue,
    SelectDay,
  },
  setup(props, context) {
    const query = reactive({
      localDate: timeStampToTime("", "upload"),
      type: props.type,
      produceOrTpc: props.produceOrTpc
    });
    const store = useStore();

    const userId = computed(() => store.state.user.user.id);

    const productColumns = [
      {
        title: "序号",
        dataIndex: "id",
        width: 80,
        align: "center",
      },
      {
        title: "检查模块",
        dataIndex: "checkModule",
        width: 120,
        align: "center",
      },
      {
        title: "检查内容",
        dataIndex: "checkContent",
        width: 165,
        align: "center",
      },
      {
        title: "检查结果",
        dataIndex: "checkResults",
        width: 165,
        align: "center",
        slots: {
          customRender: "checkResults",
        },
      },
      {
        title: "图片",
        dataIndex: "picture",
        width: 165,
        align: "center",
        slots: {
          customRender: "picture",
        },
      },
      {
        title: "视频",
        dataIndex: "video",
        width: 165,
        align: "center",
        slots: {
          customRender: "video",
        },
      },
      {
        title: "不合格原因",
        dataIndex: "unqualifiedReason",
        width: 165,
        align: "center",
      },
      {
        title: "批评教育",
        slots: {
          customRender: "isEducation",
        },
        width: 120,
        align: "center",
      },
      {
        title: "员工态度",
        dataIndex: "employeeAttitude",
        width: 120,
        align: "center",
      },
      {
        title: "培训",
        slots: {
          customRender: "isTrain",
        },
        width: 60,
        align: "center",
      },
      {
        title: "操作",
        slots: {
          customRender: "action",
        },
        width: 120,
        align: "center",
        fixed: "right",
      },
    ];

    const tableLoading = ref(false);

    const searchRef = ref();

    const fqcRef = ref();

    const tableScrollRef = ref();

    const { id, username } = useStore().state.user.user;

    const initData = reactive([
      {
        id: null,
        checkModule: "区域状态标识",
        checkContent: null,
        localDate: null,
        checkResults: null,
        picture: null,
        unqualifiedReason: null,
        video: null,
        isEducation: null,
        project: "swan",
        employeeAttitude: null,
        isTrain: null,
        userId: id,
        username: username,
      },
      {
        id: null,
        checkModule: "仪器设备",
        checkContent: null,
        localDate: null,
        checkResults: null,
        picture: null,
        unqualifiedReason: null,
        video: null,
        isEducation: null,
        project: "swan",
        employeeAttitude: null,
        isTrain: null,
        userId: id,
        username: username,
      },
      {
        id: null,
        checkModule: "工装工具",
        checkContent: null,
        localDate: null,
        checkResults: null,
        picture: null,
        unqualifiedReason: null,
        video: null,
        isEducation: null,
        project: "swan",
        employeeAttitude: null,
        isTrain: null,
        userId: id,
        username: username,
      },
      {
        id: null,
        checkModule: "在岗",
        checkContent: null,
        localDate: null,
        checkResults: null,
        picture: null,
        unqualifiedReason: null,
        video: null,
        isEducation: null,
        project: "swan",
        employeeAttitude: null,
        isTrain: null,
        userId: id,
        username: username,
      },
      {
        id: null,
        checkModule: "其他违规",
        checkContent: null,
        localDate: null,
        checkResults: null,
        picture: null,
        unqualifiedReason: null,
        video: null,
        isEducation: null,
        project: "swan",
        employeeAttitude: null,
        isTrain: null,
        userId: id,
        username: username,
      },
    ]);

    const tableData = reactive([]);

    const getTableData = () => {
      tableLoading.value = true;
      getStationCheckList(query)
        .then((res) => {
          tableLoading.value = false;
          tableData.length = 0;
          initData.forEach((item) => {
            Object.keys(item).forEach((key) => {
              if (
                key === "username" ||
                key === "userId" ||
                key === "project" ||
                key === "checkModule"
              ) {
                return;
              }
              item[key] = null;
            });
          });

          if (
            res.code === 200 &&
            res.message === "成功" &&
            res.data &&
            res.data &&
            res.data[props.type]
          ) {
            initData.forEach((item) => {
              const [find] = res.data[props.type].filter(
                (find) => item.checkModule === find.checkModule
              );
              if (find) {
                Object.keys(find).forEach((key) => {
                  item[key] = find[key];
                });
              }
            });
          }
          tableData.push(...initData);
        })
        .catch((err) => {
          tableLoading.value = false;
          console.log(err, "报错");
        });
    };

    const handleDelete = (record) => {
      showModal({
        title: "提示",
        toastText: "确认删除？",
        success: () => {
          deleteStationCheck([record.id])
            .then((res) => {
              Toast(res.code === 200 ? "success" : "warning", res.message, 3);
              if (res.code === 200) {
                getTableData();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    const userSelectDay = (time) => {
      if (time) {
        query.localDate = time;
        getTableData();
      }
    };

    const handleEdit = (data) => {
      fqcRef.value.openModal("editStationCheck", data);
    };

    const handleUpdateAbnormalProblem = () => {
      fqcRef.value.openModal("addStationCheck");
    };

    const updateTable = () => {
      getTableData();
    };

    const tabActivekey = inject("tabActivekey", null);
    watch(
      () => tabActivekey,
      (val) => {
        if (val.value === props.type) {
          getTableData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    const cascadeDate = inject("cascadeDate", null);
    watch(
      () => cascadeDate,
      (val) => {
        if (!val.value) return;
        const date = val.value.format("YYYY-MM-DD");
        if (date !== query.localDate) {
          query.localDate = date;
          getTableData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      userId,
      query,
      handleDelete,
      userSelectDay,
      productColumns,
      searchRef,
      fqcRef,
      tableData,
      tableLoading,
      tableScrollRef,
      handleUpdateAbnormalProblem,
      updateTable,
      handleEdit,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
